export const RatePlanTypeEnum = Object.freeze({
    ADVISER: 'ADVISER',
    PLATFORM: 'PLATFORM'
});

export default RatePlanTypeEnum;
